import { useQueryClient, useMutation } from "@tanstack/react-query";

import { useMyStyleModalStore } from "../../../js/stores/my-style-modal-store";
import { MyStyleModal } from "./my-style-modal";
import { Dialog, DialogContent } from "../shared/modal";
import { postMyStyle } from "../../../js/api/my-style/post-my-style";

export const MyStyleWidget = () => {
  const isModalOpen = useMyStyleModalStore((state) => state.isModalOpen);
  const openModal = useMyStyleModalStore((state) => state.openModal);
  const closeModal = useMyStyleModalStore((state) => state.closeModal);
  const updateIsModalOpen = useMyStyleModalStore(
    (state) => state.updateIsModalOpen
  );
  const queryClient = useQueryClient();
  const updateStyle = useMutation({
    mutationFn: postMyStyle,
    onSuccess: (data) => {
      queryClient.setQueryData(["my-style-widget"], data);
    },
  });

  const handleClick = () => {
    openModal();
    const myStyleFormData = new FormData(
      document.getElementById("my-profile__form--my-style")
    );
    const myStyleData = {
      ProfileRoomType: myStyleFormData.get("ProfileRoomType"),
      ProfileColourType: myStyleFormData.get("ProfileColourType"),
      FavouriteRoomTypes: myStyleFormData.getAll("FavouriteRoomTypes"),
      FavouriteColourTypes: myStyleFormData.getAll("FavouriteColourTypes"),
      FavouriteStyleWords: myStyleFormData.getAll("FavouriteStyleWords"),
    };
    updateStyle.mutate(myStyleData);
  };

  return (
    <>
      <button
        type="button"
        className="my-profile__check-button"
        onClick={handleClick}
      >
        See my style
      </button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => updateIsModalOpen(false)}
          onOpenChange={updateIsModalOpen}
        >
          <DialogContent>
            <MyStyleModal closeModal={closeModal} error={updateStyle.error} />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
